module.exports = __webpack_public_path__ + "static/media/imgab2.aed5c316.png";